export default "__VITE_ASSET__870a1529__"